import { render, staticRenderFns } from "./Home.data-manager-dsps.vue?vue&type=template&id=6f207d26&scoped=true&"
import script from "./Home.data-manager-dsps.vue?vue&type=script&lang=js&"
export * from "./Home.data-manager-dsps.vue?vue&type=script&lang=js&"
import style0 from "./Home.data-manager-dsps.vue?vue&type=style&index=0&id=6f207d26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f207d26",
  null
  
)

export default component.exports